import state from './moduloVerificarQrAprobacionesState';
import mutations from './moduloVerificarQrAprobacionesMutations';
import actions from './moduloVerificarQrAprobacionesActions';
import getters from './moduloVerificarQrAprobacionesGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
